import { PIMTextField } from './PIMTextField';

export default PIMTextField;
